"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Text = _interopRequireDefault(require("../Text"));

var _styledSystem = require("styled-system");

var _get = _interopRequireDefault(require("lodash/get"));

var _polished = require("polished");

var _excluded = ["totalImages", "selectedIndex", "variant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var mediaCounterStyle = (0, _styledSystem.variant)({
  key: 'mediaCounter'
});

var getBackgroundWithOpacity = function getBackgroundWithOpacity(props) {
  var _mediaCounterStyle = mediaCounterStyle(props),
      backgroundColor = _mediaCounterStyle.backgroundColor,
      opacity = _mediaCounterStyle.opacity;

  return (0, _polished.rgba)(backgroundColor, opacity);
};

var MediaCounterWrapper = ( /*#__PURE__*/0, _styledBase["default"])(_Text["default"], {
  target: "e1uzabtl0",
  label: "MediaCounterWrapper"
})("padding:", (0, _styledSystem.themeGet)('space.1'), " ", (0, _styledSystem.themeGet)('space.2'), ";font-size:", (0, _styledSystem.themeGet)('fontSizes.s'), ";border-radius:", (0, _styledSystem.themeGet)('radii.default'), ";color:", function (props) {
  return (0, _get["default"])(mediaCounterStyle(props), 'color');
}, ";background-color:", function (props) {
  return getBackgroundWithOpacity(props);
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL01lZGlhQ291bnRlci9NZWRpYUNvdW50ZXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZXdDIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9jb21wb25lbnRzL01lZGlhQ291bnRlci9NZWRpYUNvdW50ZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBUZXh0IGZyb20gJ2NvbXBvbmVudHMvVGV4dCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyB0aGVtZUdldCwgdmFyaWFudCB9IGZyb20gJ3N0eWxlZC1zeXN0ZW0nO1xuaW1wb3J0IGdldCBmcm9tICdsb2Rhc2gvZ2V0JztcbmltcG9ydCB7IHJnYmEgfSBmcm9tICdwb2xpc2hlZCc7XG5cbmNvbnN0IG1lZGlhQ291bnRlclN0eWxlID0gdmFyaWFudCh7IGtleTogJ21lZGlhQ291bnRlcicgfSk7XG5cbmNvbnN0IGdldEJhY2tncm91bmRXaXRoT3BhY2l0eSA9IChwcm9wcykgPT4ge1xuICBjb25zdCB7IGJhY2tncm91bmRDb2xvciwgb3BhY2l0eSB9ID0gbWVkaWFDb3VudGVyU3R5bGUocHJvcHMpO1xuICByZXR1cm4gcmdiYShiYWNrZ3JvdW5kQ29sb3IsIG9wYWNpdHkpO1xufTtcblxuY29uc3QgTWVkaWFDb3VudGVyV3JhcHBlciA9IHN0eWxlZChUZXh0KWBcbiAgcGFkZGluZzogJHt0aGVtZUdldCgnc3BhY2UuMScpfSAke3RoZW1lR2V0KCdzcGFjZS4yJyl9O1xuICBmb250LXNpemU6ICR7dGhlbWVHZXQoJ2ZvbnRTaXplcy5zJyl9O1xuICBib3JkZXItcmFkaXVzOiAke3RoZW1lR2V0KCdyYWRpaS5kZWZhdWx0Jyl9O1xuICBjb2xvcjogJHsocHJvcHMpID0+IGdldChtZWRpYUNvdW50ZXJTdHlsZShwcm9wcyksICdjb2xvcicpfTtcbiAgYmFja2dyb3VuZC1jb2xvcjogJHsocHJvcHMpID0+IGdldEJhY2tncm91bmRXaXRoT3BhY2l0eShwcm9wcyl9O1xuYDtcblxuY29uc3QgTWVkaWFDb3VudGVyID0gKHtcbiAgdG90YWxJbWFnZXMsXG4gIHNlbGVjdGVkSW5kZXgsXG4gIHZhcmlhbnQgPSAnZGFyaycsXG4gIC4uLnJlc3Rcbn0pID0+IChcbiAgPE1lZGlhQ291bnRlcldyYXBwZXIgdmFyaWFudD17dmFyaWFudH0gey4uLnJlc3R9PlxuICAgIHtzZWxlY3RlZEluZGV4fSAvIHt0b3RhbEltYWdlc31cbiAgPC9NZWRpYUNvdW50ZXJXcmFwcGVyPlxuKTtcblxuTWVkaWFDb3VudGVyLnByb3BUeXBlcyA9IHtcbiAgLi4udmFyaWFudC5wcm9wVHlwZXMsXG4gIHRvdGFsSW1hZ2VzOiBQcm9wVHlwZXMubnVtYmVyLmlzUmVxdWlyZWQsXG4gIHNlbGVjdGVkSW5kZXg6IFByb3BUeXBlcy5udW1iZXIuaXNSZXF1aXJlZCxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IE1lZGlhQ291bnRlcjtcbiJdfQ== */"));

var MediaCounter = function MediaCounter(_ref) {
  var totalImages = _ref.totalImages,
      selectedIndex = _ref.selectedIndex,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'dark' : _ref$variant,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(MediaCounterWrapper, (0, _extends2["default"])({
    variant: variant
  }, rest), selectedIndex, " / ", totalImages);
};

MediaCounter.propTypes = _objectSpread(_objectSpread({}, _styledSystem.variant.propTypes), {}, {
  totalImages: _propTypes["default"].number.isRequired,
  selectedIndex: _propTypes["default"].number.isRequired
});
var _default = MediaCounter;
exports["default"] = _default;